import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InfoDialogComponent {


  @Input() info: string = '';
  @Input() buttonText: string = $localize`:Info dialog button text | Text for button in info dialog@@infoDialogButtonText:Ok`;
  @Output() dialogClosed: EventEmitter<(void|boolean)> = new EventEmitter<(void|boolean)>();

  closeDialog() {
    this.dialogClosed.emit();
  }

  closeDialogWithResult() {
    this.dialogClosed.emit(true);
  }

  ngOnDestroy() {
  }

}
